import { DataSourceContext, SupportAgentTicket } from "@src/types/support";

/**
 * Resolves the machine context shown in ticket UIs.
 *
 * Prefers the server-populated `context` list (v4.0.0 service-support API);
 * falls back to the ticket's `machine` attributes for payloads/flows that
 * only carry the machine block.
 */
export const returnMachineContext = (
  ticket: SupportAgentTicket,
): DataSourceContext | null => {
  const fromContext = ticket.context?.find(
    (contextItem) => contextItem.type === "DATA_SOURCE_CONTEXT",
  );
  if (fromContext) {
    return fromContext;
  }

  const machine = ticket.machine;
  if (!machine || (!machine.machine_name && !machine.machine_id)) {
    return null;
  }

  return {
    type: "DATA_SOURCE_CONTEXT",
    source_id: machine.machine_id ?? "",
    source_dsn: machine.source_dsn ?? "",
    source_name: machine.machine_name ?? machine.machine_id ?? "",
  };
};
